export const formatLabel = (label) => {
    return label === undefined
        ? ''
        : label
            .replace(':plus', '<span style="font-style: italic; color: #F50537; font-weight: 700">:plus</span>')
            .replace('Audi', '<span style="color: #F50537; font-weight: 700">Audi</span>');
};
